import { Component } from '@angular/core';

@Component({
  selector: 'app-about-avaana',
  templateUrl: './about-avaana.component.html',
  styleUrls: ['./about-avaana.component.scss']
})
export class AboutAvaanaComponent {}
